import { render, staticRenderFns } from "./AllegeDetail.vue?vue&type=template&id=6864a15c"
import script from "./AllegeDetail.vue?vue&type=script&lang=js"
export * from "./AllegeDetail.vue?vue&type=script&lang=js"
import style0 from "./AllegeDetail.vue?vue&type=style&index=0&id=6864a15c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports